import { FC, useMemo } from 'react'
import { UseChartContext } from 'components/atoms/chart/useChart'
import moment from 'moment'
import styles from 'components/atoms/chart/ChartHighlight/ChartHighlight.styl'

type ChartHighlightProps = {
  context: UseChartContext
  index: number
  height: number
}

export const ChartHighlight: FC<ChartHighlightProps> = (props) => {
  const { index, context, height } = props

  return useMemo(() => {
    const date = context.xArray[index]
    const left = context.scaleX(date)
    const maxAmount = Math.max(...context.groupedByX[date])
    const maxY = context.scaleY(maxAmount)
    const minY = context.scaleY(context.yRange[0])
    const isToday = moment(date).startOf('day').valueOf() === moment().startOf('day').valueOf()

    return (
      <g transform={ `translate(${ left })` } className={ styles.chartHighlight }>
        <line y1={ minY + 6 } y2={ maxY } />
        <text transform={ `translate(0,${ height + 19 })` }>
          { isToday && 'TODAY' }
          { !isToday && moment(date).format('Do') }
        </text>
      </g>
    )

  }, [context, index, height])
}
